import CartModalController from "emun.cart/cart-modal.controller.es6";
import modals from "webmodals/modals";
import template from "emun.cart/shipping-location-picker.htm";
import retailerConfig from "emun.retailer/retailer.config";

class ShippingLocationPickerController extends CartModalController {
  constructor($session, $cart, $uibModalInstance, options) {
    "ngInject";
    super($session, $cart, $uibModalInstance, options); // TODO: options?
    let $ctrl = this;
    $ctrl.retailerConfig = retailerConfig;
  }

  select(shippingLocation) {
    let $ctrl = this;
    $ctrl.picker.selecting.notify(shippingLocation);
    if (!shippingLocation.companyName)
      shippingLocation.companyName = shippingLocation.name;
    return $ctrl.$cart.applyShippingLocation(shippingLocation).then((res) => {
      $ctrl.$close(res);
      $ctrl.$cart.load();
      $ctrl.picker.selected.notify(res);
    });
  }
  submit(shippingLocation) {
    let $ctrl = this;
    $ctrl.select(shippingLocation);
  }
  create() {
    let $ctrl = this;
    if ($ctrl.retailerConfig.newLocationConfirmation) {
      return modals
        .confirm(
          "Are you sure you want to create a new shipping location?",
          "Create Shipping Location"
        )
        .result.then(function () {
          $ctrl.picker.creating.notify($ctrl);
          $ctrl.$dismiss({ reason: "create" });
        });
    } else {
      $ctrl.picker.creating.notify($ctrl);
      $ctrl.$dismiss({ reason: "create" });
    }
  }
  edit(shippingLocation) {
    let $ctrl = this;
    $ctrl.picker.editing.notify({ update: true, ...shippingLocation });
    $ctrl.$dismiss({ reason: "edit", shippingLocation });
  }
  delete(shippingLocation) {
    let $ctrl = this;
    if (!shippingLocation.retailerId)
      shippingLocation.retailerId = shippingLocation.meta.RetailerId;
    $ctrl.picker.deleting.notify(shippingLocation);
    return $ctrl.$cart.deleteShippingLocation(shippingLocation).then((res) => {
      $ctrl.query.load(true);
      $ctrl.picker.deleted.notify(res);
    });
  }
}

export function ShippingLocationPickerFactory($cart, $q, AutoQueryLegacy) {
  "ngInject";
  class ShippingLocationPicker extends AutoQueryLegacy {
    constructor(options) {
      if (!options) options = {};
      //console.debug("options", options);
      let b2c = $cart.businessModel === "Retail";
      let purchaserType = b2c ? "Consumer" : "Retailer";
      let url = `QueryShippingLocations/${$cart.businessModel}/${
        $cart.retailerId
      }.json?JsConfig=ExcludeDefaultValues&StatusNotEqualTo=Inactive&Fields=${
        options.fields || options.selectFields || "*"
      }`;
      let aqOptions = angular.extend(
        { url, autoLoad: false, append: false, take: 100 },
        options
      );
      super(aqOptions);
      let picker = this;
      [
        "editing",
        "creating",
        "selecting",
        "selected",
        "deleting",
        "deleted",
      ].forEach((k) => {
        picker[k] = $q.defer();
        picker[k].on =
          picker[k].subscribe =
          picker[k].sub =
            (cb) => picker[k].promise.finally(null, cb);
      });
    }
    open(current) {
      let picker = this;
      if (!current) current = $cart.shippingLocation;
      let modalInstance = (picker.modal = modals.open({
        size: "lg shipping-location-picker-modal",
        templateUrl: template,
        controller: ShippingLocationPickerController,
        bindToController: true,
        controllerAs: "$ctrl",
        resolve: {
          options: () => {
            return { current, picker, query: picker };
          },
        },
      }));

      return modalInstance.result;
    }
  }
  return ShippingLocationPicker;
}

export function ShippingLocationPickerDirectiveFactory(
  ShippingLocationPicker,
  $parse
) {
  return {
    scope: false,
    link: function (scope, element, attr) {
      let picker = new ShippingLocationPicker(
        scope.$eval(attr.autoQueryOptions)
      );
      let fieldName =
        attr.ngModel ||
        attr.shippingLocationPicker ||
        attr.shippingLocationPicker ||
        "shippingLocationPicker";
      picker.linkDirective(scope, attr);
      fieldName && $parse(fieldName).assign(scope, picker);

      var $targets = attr.clickSelector
        ? element.find(attr.clickSelector)
        : element;
      $targets.on("click", (e) => picker.open(scope.$eval(attr.current)));
    },
  };
}
